import { render, staticRenderFns } from "./commonWords.vue?vue&type=template&id=8744a5b4&scoped=true"
import script from "./commonWords.vue?vue&type=script&lang=js"
export * from "./commonWords.vue?vue&type=script&lang=js"
import style0 from "./commonWords.vue?vue&type=style&index=0&id=8744a5b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8744a5b4",
  null
  
)

export default component.exports